import { ENV } from '@shared/config';
import type { Signatureartist, SignatureartistFilter } from '@shared/types';
import { decodeHtmlEntities } from '@shared/utils';

// eslint-disable-next-line import/no-internal-modules
import { getClientNoCache } from '../libs/auth-context/token';

type TMeta = {
  meta_description: string;
  meta_h1: string;
  meta_keywords: string;
  meta_title: string;
};
type TBreadcrumb = {
  title: string;
  url: string | null;
}[];

type TResponse = {
  data: Signatureartist;
  meta: TMeta;
  filter: SignatureartistFilter;
  breadcrumb: TBreadcrumb;
};

export async function getSignatureartist({ name }: { name: string }): Promise<TResponse> {
  const requestLink = `${ENV.API}/signatureartist/${name}?lang=${ENV.LANG}`;

  const noChach = await getClientNoCache();
  const res = await fetch(requestLink, {
    cache: noChach ? 'no-store' : undefined,
    next: noChach ? undefined : { revalidate: ENV.REVALIDATE_NOTE_LIST_S, tags: ['NOTES'] },
  });
  const data = (await res.json()) as TResponse;

  return decodeHtmlEntities(data);
}
